/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Create Account Request Body
 * @export
 * @interface ConfirmAccountRequest
 */
export interface ConfirmAccountRequest {
    /**
     * Confirm Account Token
     * @type {string}
     * @memberof ConfirmAccountRequest
     */
    token: string;
    /**
     * Confirm Account Password
     * @type {string}
     * @memberof ConfirmAccountRequest
     */
    password: string;
    /**
     * Confirm Account Custom Username
     * @type {string}
     * @memberof ConfirmAccountRequest
     */
    customUsername: string;
    /**
     * First Name
     * @type {string}
     * @memberof ConfirmAccountRequest
     */
    firstName: string;
    /**
     * Last Name
     * @type {string}
     * @memberof ConfirmAccountRequest
     */
    lastName: string;
}

/**
 * Check if a given object implements the ConfirmAccountRequest interface.
 */
export function instanceOfConfirmAccountRequest(value: object): value is ConfirmAccountRequest {
    if (!('token' in value) || value['token'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    if (!('customUsername' in value) || value['customUsername'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    return true;
}

export function ConfirmAccountRequestFromJSON(json: any): ConfirmAccountRequest {
    return ConfirmAccountRequestFromJSONTyped(json, false);
}

export function ConfirmAccountRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfirmAccountRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'],
        'password': json['password'],
        'customUsername': json['custom_username'],
        'firstName': json['first_name'],
        'lastName': json['last_name'],
    };
}

export function ConfirmAccountRequestToJSON(value?: ConfirmAccountRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'token': value['token'],
        'password': value['password'],
        'custom_username': value['customUsername'],
        'first_name': value['firstName'],
        'last_name': value['lastName'],
    };
}

